import script from "./AddQuotationItemModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddQuotationItemModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddQuotationItemModal.vue?vue&type=style&index=0&id=cb497496&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb497496"]])

export default __exports__